import { Icon } from "common/Icon";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import styles from "./EmptyPlaceholder.scss";

export const EmptyPlaceholder = ({ pzContained, noPoints }) => {
  return (
    <div className={styles.EmptyPlaceholder}>
      <div className={styles.border}>
        <Icon i="logo-rwgps" size={64} />
      </div>
      <div className={styles.text}>
        {noPoints ? (
          <T id="EmptyPlaceholder.manuallyLogged" defaultMessage="Manually logged ride" />
        ) : (
          <T id="EmptyPlaceholder.inPz" defaultMessage="No public data" />
        )}
      </div>
    </div>
  );
};
